export default "__VITE_ASSET__C3wOvuB6__"